import * as React from 'react'
import * as ReactDOM from "react-dom";
import {CommandCaller} from "../lib/commands";
import {redirect, RedirectProps} from "../common/common";
import {CallJs} from "../lib/types";
import {TemplateRevision, TemplateRevisionFromPHP} from "./version-history/data";
import {VersionHistoryList} from "./version-history/presentation";

type GetTemplateDataProps = {
	ajaxPageUrl:string
}

export const getTemplateGridData = (props:GetTemplateDataProps) => {
	return (callback:(_:string) => void) => {
		const cc = new CommandCaller(props.ajaxPageUrl)
		cc.runGet('templates', {}).then(
			(response) => { callback((response as {content:string}).content) }
		)
	}
}

export const addTemplate = (props:RedirectProps) => {
	return () => {
		redirect(props)
	}
}

export const editTemplate = (props:RedirectProps) => {
	return (id:string) => {
		redirect({pageUrl:`${props.pageUrl}/${id}`})
	}
}

type TemplateGridActionProps = {
	ajaxPageUrl:string
}

export const deleteTemplates = (props:TemplateGridActionProps) => {
	return (ids:string) => {
		const plural = ids.split(',').length > 1 ? 's' : '';
		if(confirm(`Are you sure you want to permanently delete the selected template${plural}?`)) {
			const cc = new CommandCaller(props.ajaxPageUrl);
			cc.runPost('delete templates', {ids: ids}).then(
				() => { refreshTemplatesGrid() }
			)
		}
	}
}

export const copyTemplates = (props:TemplateGridActionProps) => {
	return (ids:string) => {
		const cc = new CommandCaller(props.ajaxPageUrl);
		cc.runPost('copy templates', {ids: ids}).then(
			() => { refreshTemplatesGrid() }
		)
	}
}

const refreshTemplatesGrid = () => { new HtmlDataGrid('templatesDataGrid').refresh() }

type VersionHistoryParams = {
	templateVersions: TemplateRevisionFromPHP[]
	editTemplatePageUrl: string
	viewTemplatePageUrl: string
	activeVersion: number
	viewingVersion: number
}

export const versionHistory:CallJs<VersionHistoryParams> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)

	ReactDOM.render(<VersionHistoryList
		templateVersions={revisionsFromParams(params)}
		activeVersion={params.activeVersion.toString()}
		viewingVersion={params.viewingVersion.toString()}
		editTemplate={() => redirect({pageUrl: params.editTemplatePageUrl})}
		viewTemplate={(id) => redirect({pageUrl: `${params.viewTemplatePageUrl}/${id}`})}
	/>, div)
}

const revisionsFromParams = (params: VersionHistoryParams): TemplateRevision[] => {
	return params.templateVersions.map((tr:TemplateRevisionFromPHP) => {
		return {
			id: tr.id.toString(),
			title: tr.title,
			createdBy: tr.createdBy,
			createdDate: tr.createdDate,
			isActiveVersion: tr.id === params.activeVersion,
		}
	})
}



// WEBPACK FOOTER //
// ./src/communications/template.tsx